import { WifiSlash, WifiHigh } from "@phosphor-icons/react";
import { useConnection } from "@/hooks/useConnection";

export default function ConnectionBanner() {
  const status = useConnection();
  if (status === "online") return null;
  const offline = status === "offline";
  return (
    <div
      data-testid="connection-banner"
      className={`w-full px-6 py-2 text-sm font-medium flex items-center justify-center gap-2 ${
        offline ? "bg-red-600 text-white" : "bg-amber-500 text-black"
      }`}
    >
      {offline ? <WifiSlash size={16} weight="bold" /> : <WifiHigh size={16} weight="bold" />}
      {offline
        ? "Sin conexión a internet. Los cambios no se guardarán hasta que vuelva la señal."
        : "Conexión inestable o lenta. Guarda con cuidado; el sistema puede tardar en responder."}
    </div>
  );
}
